export function minigameHostClassName(productionMode: boolean): string {
  return `minigame-host${productionMode ? ' minigame-host--production' : ''}`;
}
